import { useContext, useRef } from 'react'
import { useFormikContext } from 'formik'

import { EMPTY_LIST } from '../../../../../../constants/common'
import { useNotification } from '../../../../../../hooks'
import { createDeferredPromise } from '../../../../../../utils/async'
import { EmailConfirmationTestVariablesModal } from '../../../../EmailConfirmationTestVariablesModal'
import { EmailFormContext } from '../../../../EmailForm.context'
import { EMAIL_CREATION_FORM_FIELD_NAME_TO } from '../../../EmailCreationForm.constants'
import { EmailMissingVariablesModal } from '../../../EmailMissingVariablesModal'

import {
  excludeTemplateReportsRecipients,
  getMissingVariablesTemplateReports,
  parseReportRecipients,
} from './useTestVariablesResult.utils'

export function useTestVariablesResult({ onDeleteTemplate, onEditTemplate }) {
  const { values } = useFormikContext()
  const formContext = useContext(EmailFormContext)

  const pendingTemplateReportsRef = useRef(EMPTY_LIST)

  const { handleAddErrorNotification } = useNotification()

  function handleDeleteRecipients(report) {
    pendingTemplateReportsRef.current = excludeTemplateReportsRecipients({
      report,
      templateReports: pendingTemplateReportsRef.current,
    })
  }

  function showTemplateReport({ docTemplate, report }) {
    const { promise, resolve } = createDeferredPromise()

    formContext.setModal(
      <EmailMissingVariablesModal
        docTemplate={docTemplate}
        report={report}
        reportRecipients={parseReportRecipients(
          report,
          values[EMAIL_CREATION_FORM_FIELD_NAME_TO]
        )}
        onClose={resolve}
        onDeleteRecipients={handleDeleteRecipients}
        onDeleteTemplate={onDeleteTemplate}
        onEditTemplate={onEditTemplate}
      />
    )

    return promise
  }

  async function showPendingTemplateReports() {
    while (pendingTemplateReportsRef.current.length > 0) {
      const [templateReport, ...pendingTemplateReports] =
        pendingTemplateReportsRef.current

      pendingTemplateReportsRef.current = pendingTemplateReports

      await showTemplateReport(templateReport)
    }

    formContext.onCloseModal()
  }

  function handleTestResult({ templateReports, withConfirmation }) {
    const missingVariablesTemplateReports =
      getMissingVariablesTemplateReports(templateReports)

    pendingTemplateReportsRef.current = [
      ...missingVariablesTemplateReports,
      ...pendingTemplateReportsRef.current,
    ]

    if (missingVariablesTemplateReports.length > 0) {
      showPendingTemplateReports()
    } else if (withConfirmation) {
      formContext.setModal(
        <EmailConfirmationTestVariablesModal
          onClose={formContext.onCloseModal}
        />
      )
    }

    return missingVariablesTemplateReports.length > 0
  }

  function handleTestFail({ isAutoCheck }) {
    if (!isAutoCheck) {
      formContext.onCloseModal()
    }

    handleAddErrorNotification('Error.CommonApiRequestFailKey')

    return false
  }

  return {
    handleTestFail,
    handleTestResult,
  }
}
